<template>
  <AppModalEdit
    v-model="isShowModal"
    @clickExec="onSubmit"
    title="シミュレーションからキャンペーンを作成"
    exec-button-text="読み込み"
    min-height="12vh"
  >
    <v-form ref="form" v-model="valid" @submit.prevent>
      <v-text-field
        v-if="value"
        v-model="simulationURL"
        @keypress.enter="onSubmit"
        :rules="[rules.required, rules.url]"
        autofocus
        placeholder="https://"
        class="mb-3"
      />
    </v-form>
    <p class="body-1">
      シミュレーションリンクは、
      <router-link
        :to="{ name: 'Simulation' }"
        target="_blank"
        rel="”noopener”"
      >
        シミュレーション一覧
      </router-link>
      もしくはシミュレーション画面から「共有」を押して取得して下さい。
    </p>
  </AppModalEdit>
</template>

<script>
export default {
  name: 'CampaignModalSimulationImport',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      valid: false,
      simulationURL: '',
    }
  },
  computed: {
    isShowModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    rules() {
      return {
        required: value =>
          Boolean(value !== undefined && value !== '') || '入力して下さい',
        url: value => /^http(s)?:\/\/[^.]/.test(value) || 'URLが不正です',
      }
    },
  },
  methods: {
    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false
      }

      this.$sendEventToGA('buttonClick', {
        buttonName: 'campaignModalSimulationImport.simulationImportButton',
      })
      const url = new URL(this.simulationURL)
      const hashId = url.searchParams.get('hashId')

      this.$emit('submit', hashId)
      this.closeModal()
    },
    closeModal() {
      this.simulationURL = ''
      this.isShowModal = false
    },
  },
}
</script>

<style scoped></style>
